export default function StatusBadge({ status }) {
  if (status === 'IN') {
    return <span className="badge badge-in">Přítomen</span>;
  }
  if (status === 'OUT') {
    return <span className="badge badge-out">Odešel</span>;
  }
  return <span className="badge badge-none">Bez záznamu</span>;
}
